import { render } from "./CheckoutPage.vue?vue&type=template&id=5e8f3d94&scoped=true"
import script from "@/assets/js/checkout.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/checkout.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/checkout.css?vue&type=style&index=0&id=5e8f3d94&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8f3d94"]])

export default __exports__